export const SunFogIcon = ({ className = "", ...rest }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="17"
      height="16"
      fill="none"
      viewBox="0 0 17 16"
      stroke="currentColor"
      className={className}
      {...rest}
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M12.833 8a4.333 4.333 0 10-8.666 0M3.827 3.326L3.74 3.24m9.433.086l.087-.086-.087.086zM8.5 1.386v-.053.053zM1.887 8h-.054.054zm13.28 0h-.054.054z"
      ></path>
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        d="M3.167 10h10.666M4.5 12h8M6.5 14h4"
      ></path>
    </svg>
  )
}
